import { useEffect } from 'react';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { useRouter } from 'next/router';
import { cleanHttpRefererFromStorage } from 'tracking/TrackingProvider';

export function NavigationTracker() {
  const trackEvent = useTrackEvent();
  const router = useRouter();

  useEffect(() => {
    cleanHttpRefererFromStorage();

    trackEvent('navigate_blog', {});
    trackEvent('performance: mount', {
      timeToMount: window.performance.now(),
      timeToMountType: 'page-ready',
    });

    router.events.on('routeChangeComplete', () => {
      trackEvent('navigate_blog', {});
    });

    return () => {
      cleanHttpRefererFromStorage();
      router.events.off('routeChangeComplete`', () => {
        trackEvent('navigate_blog', {});
      });
    };
  }, []);

  return null;
}
